import { queryOptions } from "@tanstack/react-query";

import { api } from "@/api/api";
import { type Trip, TripsSortOptions } from "@/features/trips/types/types";
import type {
  FindPackageByIdOutputDto,
  FindPackagesOutputDto,
} from "@/types/codegen";
import { SortOrder } from "@/types/enums";

export const tripQueryOptions = (tripId: string) =>
  queryOptions({
    queryKey: ["packages", tripId],
    queryFn: ({ signal }) =>
      api.get<FindPackageByIdOutputDto>(`/packages/packages/${tripId}`, {
        signal,
      }),
    select: (response) => response.data.data,
    throwOnError: false,
  });

type TripsQueryOptionsParams = {
  sortField?: TripsSortOptions;
  sortOrder?: SortOrder;
};

export const tripsQueryOptions = (params?: TripsQueryOptionsParams) => {
  const normalizedParams: TripsQueryOptionsParams = {
    sortField: TripsSortOptions.POSITION,
    sortOrder: SortOrder.ASC,
    ...params,
  };

  return queryOptions({
    queryKey: ["packages", normalizedParams],
    queryFn: ({ signal }) =>
      api.get<FindPackagesOutputDto>("/packages/packages", {
        signal,
        params: normalizedParams,
      }),
    select: (response): Trip[] => response.data.data.packages,
    throwOnError: false,
  });
};
